import { Drawer } from '@material-ui/core';
import { PaymentMethod } from 'app/core/api/repairer/api-repairer.types';
import { useCreatePaymentMethod } from 'app/core/api/user/api-user';
import Button from 'app/shared/components/button/Button';
import FormTextInput from 'app/shared/components/form-input/FormTextInput';
import useInputForm from 'app/shared/components/form-input/utilities/use-input-form';
import { InputTitle, PadExpand } from 'app/shared/components/misc';
import { useShowInfo } from 'app/shared/context-hooks/use-show-info.hook';
import Form from 'app/shared/frames/Form';
import { useEffectOnChanges } from 'app/tools/hooks/misc-hooks';
import React from 'react';

type Props = {
  showAddCard: boolean;
  setShowAddCard: (isVisible: boolean) => unknown;
};
export default function Cards({
  showAddCard,
  setShowAddCard,
}: Props): JSX.Element {
  const { showSnack } = useShowInfo();
  const {
    request$: createPaymentMethod$,
    sending: submitting,
    error: apiError,
  } = useCreatePaymentMethod();
  const { handleSubmit, inputProps } = useInputForm<PaymentMethod>({
    mode: 'onTouched',
    apiError,
  });
  const onSubmit = (formValues: PaymentMethod) => {
    createPaymentMethod$({
      ...formValues,
    }).subscribe(() => {
      setShowAddCard(false);
    });
  };
  useEffectOnChanges(() => {
    if (apiError && apiError.detail) {
      showSnack({ message: apiError.detail ?? '' });
    }
  }, [apiError, showSnack]);
  return (
    <>
      <Drawer
        anchor="bottom"
        open={showAddCard}
        onClose={() => setShowAddCard(false)}
      >
        <Form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
          <InputTitle>Card number</InputTitle>
          <FormTextInput
            classicPlaceholder
            controlName="number"
            placeholder="Card number"
            {...inputProps}
          />
          <InputTitle>Name on card</InputTitle>
          <FormTextInput
            classicPlaceholder
            controlName="name"
            placeholder="Card Holder Name"
            {...inputProps}
          />
          <div style={{ display: 'flex' }}>
            <div style={{ display: 'flex' }}>
              <div>
                <InputTitle>Month</InputTitle>
                <FormTextInput
                  classicPlaceholder
                  controlName="expMonth"
                  placeholder="MM"
                  {...inputProps}
                />
              </div>
              <div>
                <InputTitle>Year</InputTitle>
                <FormTextInput
                  classicPlaceholder
                  controlName="expYear"
                  placeholder="YYYY"
                  {...inputProps}
                />
              </div>
            </div>
            <div>
              <InputTitle>CVC</InputTitle>
              <FormTextInput
                classicPlaceholder
                controlName="cvc"
                placeholder="***"
                {...inputProps}
              />
            </div>
          </div>
          <PadExpand />

          <Button type="submit" pending={submitting}>
            Save
          </Button>
        </Form>
      </Drawer>
    </>
  );
}
